export const ROUTES = {
  INVITATION: "/invitation/:invitation_id",
  ADMIN: "/admin",
  ADMIN_EMPLOYEES: (id = ":employee_id") => `/admin/employees/${id}`,
  ADMIN_NOTIFICATIONS: "/admin/notifications",
  ADMIN_REQUESTS: "/admin/requests",
  ADMIN_REQUESTS_TYPE: (type = ":type", id = ":request_id") => `/admin/requests/${type}/${id}`,
  ADMIN_PROJECT_CODES: "/admin/project-codes",
  HOME: "/",
  PROFILE: "/profile",
  NOT_FOUND: "*",
  LOGIN: "/login",
  BONUS: "/bonus",
  DOCUMENTS: "/documents",
  DOCUMENT_HUB: "/document-hub",
  KNOWLEDGE_BASE: "/knowledge-base",
  VACATION: "/vacation",
  TIMESHEET: "/timesheet",
  ASSESSMENT: "/assessment",
  ADMIN_PERFORMANCE_REVIEWS: "/admin/performance-reviews",
  ADMIN_TIMESHEET: "/admin/timesheet",
  ADMIN_PERFORMANCE_REVIEW: (id = ":user_id") => `/admin/performance-reviews/${id}`,
  ASSISTANT: "/assistant",
  PEOPLE: "/people",
  PEOPLE_PROFILE: (id = ":fmno") => `/people/${id}`,
};
